// ONLY THE LATEST ANSWER LANDS. Two reads of the same thing can overlap — two
// saves in a row each re-read the invoice — and the network may answer them out
// of order. A caller takes a ticket before it asks and applies the answer only
// if no later ticket has been taken since (code review, 2026-10-03, D-271).
// Pure, so the rule is tested without mounting a component.

interface LatestRequest {
  /** Take a ticket for a new request; every earlier ticket stops being latest. */
  begin(): number
  /** Whether `ticket` is still the most recent one taken. */
  isLatest(ticket: number): boolean
}

export function latestRequest(): LatestRequest {
  let current = 0
  return {
    begin: () => ++current,
    isLatest: (ticket) => ticket === current,
  }
}
